import React from 'react';
import {connect} from 'react-redux';
import {FormattedNumber} from 'react-intl';
import {
    clearBarReportTransactions, deleteBarReport, fetchBarReportTransactions
} from '../../../../common/menu/report/transaction/actions';
import Time from '../../../components/numbers/Time';
import TypePopup from './TypePopup';
import NewPopup from './NewPopup';
import Popup from '../../popup/Popup';
import {showPopupInMenu} from '../../../../common/menu/actions';
import {fetchAllOrganizationCashboxes} from '../../../../common/cashboxes/actions';
import ArrLeftButton from '../../../components/buttons/ArrLeftButton';
import ArrRightButton from '../../../components/buttons/ArrRightButton';

class Transactions extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        page: React.PropTypes.number,
        limit: React.PropTypes.number,
        barId: React.PropTypes.number,
        max: React.PropTypes.number,
        transactions: React.PropTypes.object,
        fetchAllOrganizationCashboxes: React.PropTypes.func,
        clearBarReportTransactions: React.PropTypes.func,
        deleteBarReport: React.PropTypes.func,
        fetchBarReportTransactions: React.PropTypes.func,
        showPopupInMenu: React.PropTypes.func,
        visibleFormPopup: React.PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.nextPage = this.nextPage.bind(this);
        this.prevPage = this.prevPage.bind(this);
        this.openPopup = this.openPopup.bind(this);
    }

    nextPage() {
        const {fetchBarReportTransactions, barId, limit, page} = this.props;
        fetchBarReportTransactions(barId, limit, page + 1);
    }

    prevPage() {
        const {fetchBarReportTransactions, barId, limit, page} = this.props;
        fetchBarReportTransactions(barId, limit, page - 1);
    }

    componentWillMount() {
        const {fetchBarReportTransactions, barId, limit, page, fetchAllOrganizationCashboxes} = this.props;
        fetchBarReportTransactions(barId, limit, page);
        fetchAllOrganizationCashboxes();
    }

    componentWillUnmount() {
        const {clearBarReportTransactions} = this.props;
        clearBarReportTransactions();
    }

    openPopup() {
        const {showPopupInMenu} = this.props;
        showPopupInMenu(true);
    }

    render() {
        const {transactions, max, page, limit, barId, deleteBarReport, visibleFormPopup, msg} = this.props;

        return (
            <div className="menuPage">

                <Popup hideArrows body={<TypePopup />}/>
                {visibleFormPopup &&
                <NewPopup />
                }

                <div className="menuPage-header">
                  <div className="menuPage-header-title">
                    <div className="menuPage-title">
                        {msg.transactions.dailyReport}
                    </div>
                  </div>
                  <div className="menuPage-header-key">
                    <div className={`boxBtn color-white ${page < 1 ? 'disabled' : ''}`}
                         onClick={() => this.prevPage()}>
                        <ArrLeftButton/>
                    </div>
                  </div>
                  <div className="menuPage-header-key">
                    <div
                        className={`boxBtn color-white ${max <= limit || page === (Math.ceil(max / limit) - 1) ? 'disabled' : ''}`} onClick={() => this.nextPage()}>
                        <ArrRightButton/>
                    </div>
                  </div>
                  <div className="menuPage-header-key">
                    <div className={`boxBtn color-green`}
                         onClick={() => this.openPopup()}>
                        <div className={`boxBtn-inner`}>
                            {msg.transactions.add}
                        </div>
                    </div>
                  </div>
                </div>

              <div className="menuPage-content">
                <div className="table">
                    <div className="table-head">
                        <div className="table-head-row">
                            <div className="table-head-cell" style={{width: '10%'}}>
                                <span>{msg.transactions.time}</span>
                            </div>
                            <div className="table-head-cell" style={{width: '40%'}}>
                                <span>{msg.transactions.paied}</span>
                            </div>
                            <div className="table-head-cell" style={{width: '20%'}}>
                                <span>{msg.transactions.amount}</span>
                            </div>
                            <div className="table-head-cell" style={{width: '20%'}}>
                                <span>{msg.transactions.created}</span>
                            </div>
                        </div>
                    </div>
                    <div className="table-body">
                        {!!transactions && transactions.map((transaction, i) =>
                            <div className="table-row"
                                 key={`sentBills-${i}`}>

                                <div className="table-cell" style={{width: '10%'}}>
                                    <div className={`boxBtn text-black`}>
                                        <div className="boxBtn-inner">
                                            <Time value={transaction.get('time')}/>
                                        </div>
                                    </div>
                                </div>

                                <div className="table-cell" style={{width: '40%'}}>
                                    <div className={`boxBtn text-left text-black`}>
                                        <div className="boxBtn-inner">
                                            <span>{transaction.get('title')}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="table-cell" style={{width: '20%'}}>
                                    <div className={`boxBtn text-right text-black`}>
                                        <div className="boxBtn-inner">
                                            {transaction.get('amount') !== null &&
                                            <FormattedNumber style="decimal"
                                                             maximumFractionDigits={2}
                                                             minimumFractionDigits={2}
                                                             value={(-1) * transaction.get('amount')}/>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="table-cell" style={{width: '20%'}}>
                                    <div className={`boxBtn text-black`}>
                                        <div className="boxBtn-inner">
                                            {transaction.get('userEntityName')}
                                        </div>
                                    </div>
                                </div>

                                <div className="table-cell" style={{width: '10%'}}>
                                    <div className={`boxBtn color-red`}
                                         onClick={() => deleteBarReport(transaction.get('id'), barId, limit, page)}>
                                        <div className="boxBtn-inner">
                                            <span>{msg.global.delete}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        )}
                    </div>
                </div>
              </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    barId: state.bars.getIn(['bar', 'id']),
    limit: state.transactions.get('limit'),
    page: state.transactions.get('page'),
    max: state.transactions.get('max'),
    transactions: state.transactions.get('transactions'),
    visibleFormPopup: state.transactions.get('visibleFormPopup')
}), {
    clearBarReportTransactions, showPopupInMenu, deleteBarReport, fetchBarReportTransactions, fetchAllOrganizationCashboxes
})(Transactions);



// WEBPACK FOOTER //
// ./src/browser/menu/report/transactions/Transactions.js